var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJokeEmojiBw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 9,
    stroke: "#696969",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7032 13.8108C13.0865 13.8108 13.421 14.0119 13.594 14.3267C13.7327 14.579 13.9528 14.827 14.2407 14.827C14.5286 14.827 14.769 14.5901 14.6996 14.3107C14.4742 13.4037 13.6647 12.7683 12.7032 12.7683C11.7418 12.7683 10.9322 13.4037 10.7069 14.3107C10.6375 14.5901 10.8779 14.827 11.1658 14.827C11.4536 14.827 11.6738 14.579 11.8125 14.3267C11.9855 14.0119 12.32 13.8108 12.7032 13.8108Z",
    fill: "#696969",
    stroke: "#696969",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3458 13.8108C19.7291 13.8108 20.0635 14.0119 20.2366 14.3267C20.3753 14.579 20.5954 14.827 20.8833 14.827C21.1712 14.827 21.4116 14.5901 21.3422 14.3107C21.1168 13.4037 20.3072 12.7683 19.3458 12.7683C18.3844 12.7683 17.5748 13.4037 17.3495 14.3107C17.2801 14.5901 17.5205 14.827 17.8084 14.827C18.0962 14.827 18.3164 14.579 18.4551 14.3267C18.6281 14.0119 18.9626 13.8108 19.3458 13.8108Z",
    fill: "#696969",
    stroke: "#696969",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8759 21.2379C17.72 21.2379 19.4939 20.3756 20.6302 18.9188C20.8072 18.6918 20.7362 18.3674 20.4944 18.2111C20.2526 18.0549 19.9319 18.1264 19.7507 18.35C18.6933 19.655 17.0073 20.3583 15.3202 20.1636C14.042 20.0162 12.8484 19.3496 12.038 18.3499C11.8567 18.1263 11.536 18.0549 11.2942 18.2111C11.0524 18.3674 10.9814 18.6917 11.1585 18.9186C12.1399 20.1759 13.6164 21.0164 15.2007 21.1992C15.4262 21.2252 15.6514 21.2379 15.8759 21.2379Z",
    fill: "#696969",
    stroke: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7374 19.4577C19.0438 19.7574 19.0779 20.2373 18.846 20.6086C19.022 20.6352 19.1888 20.7135 19.3223 20.8441C19.6796 21.1937 19.6664 21.7886 19.293 22.1702L18.5537 22.9258C18.7191 22.9563 18.8749 23.0329 19.0012 23.1565C19.3585 23.5061 19.3454 24.1008 18.9719 24.4826L17.5411 25.9449L16.8821 26.6186L16.4172 27.0937L16.2909 27.2227C14.7742 28.7725 12.3595 28.8788 10.9085 27.4591C9.55039 26.1302 9.50563 23.8787 10.8024 22.3235C10.8353 22.2767 10.8718 22.2321 10.9115 22.1916L11.0163 22.0845L11.017 22.0837L11.0277 22.0729L11.6188 21.4687L12.5772 20.4892C12.9505 20.1077 13.545 20.0817 13.9022 20.4312C14.0285 20.5548 14.1084 20.7089 14.1425 20.8736L15.723 19.2584C16.0964 18.8767 16.6908 18.8508 17.048 19.2003C17.1743 19.3239 17.2542 19.4781 17.2884 19.6429L17.4127 19.516C17.7859 19.1344 18.3802 19.1082 18.7374 19.4577Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2417 20.0132C18.0764 19.8515 17.7959 19.8705 17.6149 20.0555L15.134 22.591L14.9115 22.3733L16.7873 20.4563C16.9684 20.2712 16.9811 19.9901 16.816 19.8285C16.6507 19.6668 16.3701 19.6857 16.189 19.8709L13.2608 22.8636L13.0383 22.6459L14.0982 21.5626C14.2792 21.3776 14.2919 21.0966 14.1268 20.935C13.9615 20.7733 13.6809 20.7922 13.4999 20.9772L12.6687 21.8267L12.6685 21.8264L12.1557 22.3505C12.1551 22.3511 12.1548 22.352 12.1541 22.3527L12.0552 22.4537C12.0317 22.4778 12.0111 22.5032 11.9933 22.5298C10.9769 23.7265 10.9503 25.425 11.9701 26.4229C13.0419 27.4716 14.863 27.3487 16.0374 26.1485L16.0376 26.1487L16.1471 26.0368L16.5503 25.6246L17.122 25.0404L17.1218 25.0402L18.3628 23.7718C18.5438 23.5869 18.5567 23.3057 18.3914 23.144C18.2262 22.9824 17.9454 23.0014 17.7644 23.1864L16.5233 24.4548L16.3009 24.2372L18.6809 21.8048C18.8619 21.6198 18.8747 21.3388 18.7094 21.1771C18.5442 21.0154 18.2635 21.0344 18.0825 21.2194L15.9547 23.394L15.7323 23.1764L18.2132 20.6409C18.3943 20.4558 18.4069 20.1749 18.2417 20.0132Z",
    fill: "#FAFEFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJokeEmojiBw);
export default __webpack_public_path__ + "static/media/joke_emoji_bw.69020e943bad946f52f7cd7ef8cf76df.svg";
export { ForwardRef as ReactComponent };